import { useCallback } from 'react'
import Cookies from 'js-cookie'
import { useApolloClient } from '@apollo/client/react'
import { VENDURE_LANGUAGE_CODE_HEADER_KEY } from '@/config'
import { useChannelStore } from '@/store/channel'
import { toCatalogCode } from '@/i18n/languages'
import { loadLanguage } from '@/i18n'

export function useChangeLanguage() {
  const client = useApolloClient()
  const setCurrentLanguageCode = useChannelStore((store) => store.setCurrentLanguageCode)

  return useCallback(
    async (vendureLanguageCode: string) => {
      Cookies.set(VENDURE_LANGUAGE_CODE_HEADER_KEY, vendureLanguageCode, { expires: 365 })
      setCurrentLanguageCode(vendureLanguageCode)
      await loadLanguage(toCatalogCode(vendureLanguageCode))
      client.resetStore().catch((err) => console.error('Failed to reset Apollo store after language change.', err))
    },
    [client, setCurrentLanguageCode]
  )
}
